import React, {Component} from 'react';
import {Col, Grid, Row} from "react-bootstrap";
import TopBreadcumb from "../../../../componentsTopsa/breadcrumbs/TopBreadcumb";
import SubHeader from "../../../../shared/sidebar/SubHeader";
import SidebarComponent from "../../../../shared/sidebar/SidebarComponent";
import Links from "../../../../utilities/linksConfig/Links";
import ReactNotify from 'react-notify'
import WynajemService from "../WynajemService";
import ZarzadzanieTable from "./ZarzadzanieTable";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import KonfiguracjaHeader from "../../../../shared/headers/KonfiguracjaHeader";
import {Redirect} from "react-router-dom";
import {TopInputDate} from "../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonAction, TopSimpleButton} from "../../../../componentsTopsa/buttons/TopButtons";
import moment from "moment";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import TabGrid from "../../../../utilities/TabGrid";
import acc from "accounting";
import PopupDaneDoFaktury from "../popupDaneDoFaktury/PopupDaneDoFaktury";
import FakturaComponent from "../../../fakturaModule/components/FakturaComponent";
import LogowanieService from "../../../logowanie/LogowanieService";

export default class ZarzadzanieContainer extends Component {

    constructor(props) {
        super(props);

        let dataOd = moment().startOf('month').format().substr(0,16).toString()
        let dataDo = moment().endOf('month').format().substr(0,16).toString()

        if (localStorage.getItem('listaWynajem') !== null && localStorage.getItem('listaWynajem') !== undefined){
            dataOd = JSON.parse(localStorage.getItem('listaWynajem')).dataOd
            dataDo = JSON.parse(localStorage.getItem('listaWynajem')).dataDo
            localStorage.removeItem('listaWynajem')
        }

        this.state = {
            dane: '',
            dataOd: dataOd,
            dataDo: dataDo,
            wynajmy: [],
            wynajem: null,
            pokazFormularz: false,
            wlaczSzukanie: true,
            podsumowanie: [],
            obiektDoFaktury: null,
            pokazPopupDoFaktury: false,
        };

        localStorage.removeItem('EBUS_EdycjaWynajem')

        this.onClickEdytuj = this.onClickEdytuj.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickWystawFakture = this.onClickWystawFakture.bind(this)
        this.onChangeOd = this.onChangeOd.bind(this)
        this.onChangeDo = this.onChangeDo.bind(this)
    }

    componentWillMount() {
        this.pobierzWynajem()
    }

    onChangeOd(e) {
        this.setState({dataOd: e})
    }

    onChangeDo(e) {
        this.setState({dataDo: e})
    }

    pobierzWynajem() {
        WynajemService.getWynajemData(moment(this.state.dataOd).format().substr(0,16), moment(this.state.dataDo).endOf('day').format().substr(0,16))
            .then(function (response) {
                let suma = 0;
                let i = 0;
                for (i = 0; i < response.data.length; i++) {
                    suma += response.data[i].cenaNajmu
                }
                this.setState({
                    wynajmy: response.data,
                    podsumowanie: [{okres: this.state.dataOd.substr(0,10) + ' - ' + this.state.dataDo.substr(0,10), ilosc: i, suma: suma}]
                })
            }.bind(this))
    }

    onClickEdytuj(row) {
        localStorage.setItem('EBUS_EdycjaWynajem', JSON.stringify(row.idWy))
        localStorage.setItem('listaWynajem', JSON.stringify({dataOd: this.state.dataOd, dataDo: this.state.dataDo}))
        this.setState({pokazFormularz: (Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))? false : true})
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc wynajem: ' + obj.idWy)) {
            WynajemService.usunWynajem(obj.idWy).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success('Pomyślnie usunięto wynajem', "", 3000)
                    this.pobierzWynajem()
                }
                else {
                    this.refs.notificator.error('Wystąpił błąd podczas usuwania wynajmu', "", 3000)
                }
            }.bind(this))

        }
    }

    onClickWystawFakture(obj) {
        let obiekt = {
            formaPlatnosci: (obj.formaPlatnosci === 'GOTÓWKA') ? {value: 'GK', label: 'Gotówka'} : {
                value: 'PR',
                label: 'Przelew'
            },
            pozycje: [{
                index: new Date().getTime(),
                nazwa: 'WYNAJEM ' + obj.tytul,
                ilosc: 1,
                cena_netto: (parseFloat(obj.cenaNajmu / 1.23)).toFixed(2),
                wartosc_netto: (parseFloat(obj.cenaNajmu / 1.23)).toFixed(2),
                vat: 23,
                kwota_vat: (obj.cenaNajmu - (parseFloat(obj.cenaNajmu / 1.23))).toFixed(2),
                wartosc_brutto: obj.cenaNajmu,
            }]
        }

        this.setState({obiektDoFaktury: obiekt, pokazPopupDoFaktury: true})
    }

    filtrujWyniki() {
        WynajemService.getWynajemData(moment(this.state.dataOd).format().substr(0,16), moment(this.state.dataDo).format().substr(0,16))
            .then(function (response) {
                let suma = 0;
                let i = 0;
                for (i = 0; i < response.data.length; i++) {
                    suma += response.data[i].cenaNajmu
                }
                this.setState({
                    wynajmy: response.data,
                    podsumowanie: [{
                        okres: moment(this.state.dataOd).format().substr(0,10) + ' - ' + moment(this.state.dataDo).format().substr(0,10),
                        ilosc: i,
                        suma: suma
                    }]
                })
            }.bind(this))
    }

    renderCena(cell, row) {
        return acc.formatMoney(cell)
    }

    render() {

        if (this.state.pokazFormularz) {
            if (localStorage.getItem('EBUS_EdycjaWynajem') === null) {
                return <Redirect to={"/konfiguracja/wynajem/formularz"}/>
            } else {
                return <Redirect to={"/konfiguracja/wynajem/" + localStorage.getItem('EBUS_EdycjaWynajem')}/>
            }

        } else

            return (
                <SidebarComponent links={Links.getKonfiguracjaLinks} currentLink={this.props.match.path}
                                  history={this.props.history}
                                  collapsedLinks={this.props.collapsedLinks}
                                  handleClickToogleSidebar={(module) => this.props.handleClickToogleSidebar(module)}>
                    <Grid fluid={true} id={'PrzystankiContainer'}>
                        <ReactNotify ref='notificator'/>
                        <Row>
                            <Col sm={12}>
                                <div id="subheader">
                                    <TopBreadcumb links={[{addressUrl: '/konfiguracja', text: 'Konfiguracja'}, {
                                        addressUrl: '/konfiguracja/wynajem/lista',
                                        text: 'Wynajem'
                                    }]}/>
                                    <SubHeader currentLink={this.props.match.path}
                                               obecnyKalendarz={this.props.obecnyKalendarz}
                                               history={this.props.history}/>
                                </div>
                            </Col>
                            <Col xs={12} lg={6}>
                                <Col lg={5}>Od:{' '}
                                    <TopInputDate className="form-control" onChange={this.onChangeOd}
                                                  value={moment(this.state.dataOd)}/>
                                </Col><Col lg={5}>Do:{' '}
                                <TopInputDate className="form-control" onChange={this.onChangeDo}
                                              value={moment(this.state.dataDo)}/>
                            </Col><Col lg={2}>
                                <TopSimpleButton text="Filtruj" onClick={() => this.filtrujWyniki()}/>
                            </Col></Col>
                            <Col xs={12} lg={6}>
                                <TopIf isTrue={(!Boolean(this.state.pokazFormularz)) && (!Boolean(LogowanieService.czyPosiadaRole(['ROLE_WYNAJEM_ODCZYT_LISTA'])))}>
                                            <KonfiguracjaHeader
                                            pokazFormularz={() => this.setState({pokazFormularz: true})}
                                            tekstDodaj={'Dodaj wynajem'}
                                            pokazButtonSzukaj={false}/>
                                </TopIf></Col>
                            <Col sm={12}>
                                <TopIf isTrue={Boolean(this.state.wynajmy)}>
                                    <ZarzadzanieTable data={this.state.wynajmy}
                                                      wlaczSzukanie={this.state.wlaczSzukanie}
                                                      handleEdytuj={this.onClickEdytuj}
                                                      handleUsun={this.onClickUsun}
                                                      handleWystawFakture={this.onClickWystawFakture}
                                    />
                                </TopIf>
                            </Col>
                            <Col sm={12}>
                                <hr/>
                                <h5 style={{fontWeight: 'bold', marginBottom: 0}}>Podsumowanie:</h5>
                            </Col>
                            <Col sm={5}>
                                <BootstrapTable data={this.state.podsumowanie} hover>
                                    <TableHeaderColumn dataField='okres' thStyle={TabGrid.tg6} tdStyle={TabGrid.tg6}
                                                       isKey>Okres</TableHeaderColumn>
                                    <TableHeaderColumn dataField='ilosc' thStyle={TabGrid.tg2}
                                                       tdStyle={TabGrid.tg2}>Ilość</TableHeaderColumn>
                                    <TableHeaderColumn dataField='suma'
                                                       dataFormat={(cell, row) => this.renderCena(cell, row)}
                                                       thStyle={TabGrid.tg4}
                                                       tdStyle={TabGrid.tg4}>Suma</TableHeaderColumn>
                                </BootstrapTable>
                            </Col>
                        </Row>
                        {
                            this.state.pokazPopupDoFaktury ?
                                <div id={'EBUSModalContainerBG'}>
                                    <div id={'modalContainer'} className={'modalFakturaDuzy'}>
                                        <div>
                                            <div id={'modalTextContent'}>
                                                <div>
                                                    <div className={'pull-right'}>
                                                        <TopButtonAction onClick={() => {
                                                            this.setState({pokazPopupDoFaktury: false})
                                                        }}
                                                                         elementStyle={{color: 'firebrick'}}
                                                                         btnColor={'default'} text={'Zamknij'}
                                                                         iconType={'fa fa-times'}
                                                        />

                                                    </div>
                                                </div>
                                                <div style={{clear: 'both', height: '10px'}}></div>
                                                <FakturaComponent
                                                    onClickZapisz={(state) => {
                                                        console.log(state)
                                                    }}
                                                    onClickAnuluj={() => {
                                                        this.setState({pokazPopupDoFaktury: false})
                                                    }}
                                                    obiektDoFaktury={this.state.obiektDoFaktury}
                                                />
                                                <div style={{clear: 'both'}}></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                ''

                        }
                    </Grid>
                </SidebarComponent>
            );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/wynajemConfig/zarzadzanie/ZarzadzanieContainer.js